module.exports = __webpack_public_path__ + "static/img/r_2.2650f29f.png";